<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col md="6">
          <v-card flat>
            <v-card-actions>
              <v-btn outlined color="secondary" to="/super-admin/courses">
                <v-icon class="pr-2" small>fa-chevron-left</v-icon>Back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col md="6">
          <v-card flat>
            <v-card-actions style="justify-content: end;">
              <h3 class="mr-4" :style="{ fontSize: $vuetify.breakpoint.smAndDown ? '16px' : '20px' }">Passmark: {{ passMark }}%</h3>
              <v-btn outlined color="primary" @click.prevent="editPassmark">
                <v-icon :class="!$vuetify.breakpoint.smAndDown ? 'pr-2' : ''"  small>fa-pencil-alt</v-icon>{{ $vuetify.breakpoint.smAndDown ? '' : 'Edit Passmark' }}
              </v-btn>
              <v-btn
                outlined
                v-if="selected.length > 0"
                color="error"
                @click.prevent="deleteSelected"
              >
                <v-icon :class="!$vuetify.breakpoint.smAndDown ? 'pr-2' : ''" small>fa-trash-alt</v-icon>{{ $vuetify.breakpoint.smAndDown ? '' : 'delete' }}
              </v-btn>
              <v-btn outlined v-else color="error" disabled>
                <v-icon :class="!$vuetify.breakpoint.smAndDown ? 'pr-2' : ''" small>fa-trash-alt</v-icon>{{ $vuetify.breakpoint.smAndDown ? '' : 'delete' }}
              </v-btn>
              <v-btn
                outlined
                color="primary"
                @click.prevent="showAddQuestionPanel"
              >
                <v-icon :class="!$vuetify.breakpoint.smAndDown ? 'pr-2' : ''" small>fa-plus</v-icon>{{ $vuetify.breakpoint.smAndDown ? '' : 'Add Question' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
          <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            v-show="!loading"
            :items="questions"
            show-select
            item-key="id"
          >
            <template v-slot:item.id="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="secondary"
                    class="mr-1"
                    outlined
                    small
                    @click.prevent="showEditQuestionPanel(item.id)"
                  >
                    <v-icon small>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span>Edit Question</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="error"
                    class="mr-1"
                    outlined
                    small
                    @click.prevent="deleteQuestion(item.id)"
                  >
                    <v-icon small>fa-trash-alt</v-icon>
                  </v-btn>
                </template>
                <span>Delete Question</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!--<v-row>
                <v-col md="12" class="text-right pa-2">
                    All tests must have a minimum of 10 questions in order to be published
                </v-col>
            </v-row>-->
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from '@/layouts/SuperAdmin';
import AddQuestion from '@/components/partner/course/tests/AddQuestion';
import EditQuestion from '@/components/partner/course/tests/EditQuestion';
import EditPassmark from '@/components/partner/course/tests/EditPassmark';
import { EventBus } from '@/event-bus.js';
import Test from '@/components/authenticated/courses/Test';
import testAPI from '@/api/test.js';
export default {
  name: 'TestPartner',
  components: {
    SuperAdminLayout,
  },
  data() {
    return {
      headers: [
        { text: 'Question', value: 'question', sortable: false },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      id: this.$route.params.id,
      questions: [],
      quiz: {},
      pagination: {},
      loading: false,
      options: {},
      selected: [],
      successMessage: 'Question Deleted',
      errorMessage: 'Question not deleted',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    selectedQuestions: function () {
      return this.selected.map((x) => {
        return x.id;
      });
    },
    passMark: function () {
      return this.quiz.pass_mark;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getQuestions();
      },
      deep: true,
    },
  },
  mounted() {
    this.getQuiz();
    this.setEventBus();
  },
  methods: {
    showTest() {
      this.$showPanel({
        component: Test,
        props: {
          quizId: this.id,
        },
        openOn: 'right',
      });
    },
    editPassmark() {
      this.$showPanel({
        component: EditPassmark,
        props: {
          id: this.quiz.id,
          passMark: this.passMark,
        },
        openOn: 'right',
      });
    },
    getQuestions() {
      this.loading = true;
      testAPI.getQuestions(this.id, this.params).then((resp) => {
        this.questions = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    getQuiz() {
      testAPI.getTest(this.id).then((resp) => {
        this.quiz = resp.data.data;
      });
    },
    deleteSelected() {
      testAPI.deleteQuestions(this.selectedQuestions).then(() => {
        this.selected = [];
        this.getQuestions();
      });
    },
    deleteQuestion(id) {
      testAPI.deleteQuestion(id).then(() => {
        this.getQuestions();
      });
    },
    setEventBus() {
      EventBus.$on('QUESTIONS_UPDATED', (payload) => {
        this.params = payload;
        this.getQuestions();
      });
      EventBus.$on('PASSMARK_UPDATED', (payload) => {
        this.quiz = payload;
      });
    },
    showEditQuestionPanel(id) {
      this.$showPanel({
        component: EditQuestion,
        props: {
          id: id,
          quizId: this.id,
        },
        openOn: 'right',
      });
    },
    showAddQuestionPanel() {
      this.$showPanel({
        component: AddQuestion,
        props: {
          id: this.id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .v-btn{
    min-width: 0 !important;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .v-btn{
    min-width: 0 !important;
  }
}
</style>